import { render, staticRenderFns } from "./PendingQuotation.vue?vue&type=template&id=10db8091&"
import script from "./PendingQuotation.vue?vue&type=script&lang=js&"
export * from "./PendingQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports